import { render, staticRenderFns } from "./ProjectInvestedDetail.vue?vue&type=template&id=934ba5b8&"
import script from "./ProjectInvestedDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectInvestedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports